<template>
  <multiselect
    class="rnp-multiselect"
    v-model="valueLocal"
    :multiple="true"
    :close-on-select="false"
    :clear-on-select="false"
    :preserve-search="true"
    selectLabel=""
    deselectLabel=""
    selectedLabel="Selecionado"
    v-bind="propsMultiselect"
  >
    <template slot="noOptions">
      <p>A lista está vazia</p>
    </template>
    <template slot="caret">
      <div class="icon-caret">
        <unicom-icone nome="chevron-down" :tamanho="20" />
      </div>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";

import isEqual from "lodash.isequal";

export default {
  components: { Multiselect },

  props: {
    propsMultiselect: {
      type: Object,
      default: () => ({
        placeholder: "",
        options: [],
        "track-by": "",
        label: ""
      })
    },
    value: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      valueLocal: null
    };
  },

  watch: {
    valueLocal: {
      deep: true,
      immediate: true,
      handler(value) {
        this.$emit("input", value);
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler(value) {
        if (isEqual(this.valueLocal, value)) return;
        this.valueLocal = value;
      }
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
@mixin style-scroll {
  * {
    scrollbar-width: thin;
    scrollbar-color: #bebebe #f1f2f1;
  }

  &::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  &::-webkit-scrollbar-thumb {
    background: #bebebe;
    border-radius: 15px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #9e9e9e;
  }

  &::-webkit-scrollbar-track {
    background: #ffffff;
    border-radius: 15px;
    box-shadow: inset 10px 1px 23px #f1f2f1;
  }
}

.rnp-multiselect {
  outline: 0;
  width: 100%;
  min-height: 35px;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #fff;
  color: #54585e;

  ::v-deep {
    .multiselect__tags {
      min-height: 35px;
      border: 1px solid #9e9e9e;
      padding: 7px 33px 7px 15px;

      input {
        font-size: 14px;
        padding: 0;
        margin-bottom: 0;

        &::placeholder,
        &::-ms-input-placeholder {
          opacity: 0.5;
          color: #707070;
        }
      }

      .multiselect__placeholder {
        color: #707070;
        opacity: 0.7;
        line-height: 20px;
        padding-top: 0;
        margin-bottom: 0;
      }

      .multiselect__tags-wrap {
        max-height: 58px;
        overflow: auto;
        display: block;
        @include style-scroll;

        .multiselect__tag {
          background-color: #b1d34b;

          .multiselect__tag-icon {
            &:hover {
              opacity: 0.6;
              background-color: #b1d34b;
            }
            &::after {
              content: "\D7";
              color: #ffffff;
              font-size: 14px;
            }
          }
        }
      }
    }
    .multiselect__content-wrapper {
      @include style-scroll;
    }
    .multiselect__option {
      white-space: initial;

      &.multiselect__option--highlight {
        background-color: #00995d;
        color: white;
      }
    }
  }

  &.multiselect--active {
    .icon-caret {
      transform: rotateZ(180deg);
    }
  }

  .icon-caret {
    display: inline-flex;
    align-items: center;
    position: absolute;
    width: 40px;
    height: 33px;
    right: 1px;
    top: 1px;
    padding: 4px 8px;
    text-align: center;

    > div {
      height: 20px;
    }
  }
}
</style>
